<header *ngIf="login" [appUser]="appUser" [login]="login" [isServiceWorkerSupported]="isServiceWorkerSupported"></header>
<div *ngIf="isServiceWorkerSupported; else serviceWorkerMessage">
  <app-outage [hidden]="!login"></app-outage>
  <app-user-alert [hidden]="!login"></app-user-alert>
  <router-outlet></router-outlet>
  <notification-flier></notification-flier>
  <shared-authority-modal
    *ngIf="showSharedAuthorityModal"
    [authority]="trackAuthorityModal"
    [sharedAuthorityNotification]="sharedAuthorityNotification"
  ></shared-authority-modal>
</div>
<ng-template #serviceWorkerMessage>
  <app-browser></app-browser>
</ng-template>
